import { Inject, Injectable, Optional } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, catchError } from 'rxjs';
import { Router } from '@angular/router';
import { MessageService } from './message.service';
import { PlatformService } from './platform.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private message: MessageService,
    @Optional() @Inject('REQUEST') private req: any,
    private platformService: PlatformService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.platformService.isServer && this.req) {
      req = req.clone({
        withCredentials: true,
        setHeaders: {
          cookie: this.req.headers.cookie ?? '',
        },
      });
    }

    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 400) {
          this.message.error('Client Error');
          return throwError(() => new Error('400'));
        } else if (err.status === 401) {
          this.router.navigate(['/login']);
          return new Observable<never>();
        } else if (err.status === 403) {
          return throwError(() => new Error('403'));
        } else {
          return throwError(() => err);
        }
      })
    );
  }
}
